import * as types from './mutation-types'
import router from '@/router/index'
import Service from '@/services'
import {
  getTokenData,
  displayInfo
} from '@/utils/helpers'

export default {
  [types.LOADING](state) {
    state.loading = true;
  },
  [types.LOADED](state) {
    state.loading = false;
  },
  [types.REDIRECT](state) {
    if (state.redirect == '' || state.redirect == '/') {
      Service.get("/Dashboards")
        .then(function (response) {
          if (response.data.length > 0)
            router.push({
              path: '/dashboard/' + response.data[0].id
            });
          else
            router.push({
              path: '/location'
            });
        })
        .catch(function (error) {});
    } else {
      router.push({
        path: state.redirect
      });
      state.redirect = ''
    }
  },
  [types.LOGIN](state) {
    state.isLoggedIn = true
    state.isInAdminRole = getTokenData().userRole === 'super_admin'
    state.isInManagerRole = getTokenData().userRole === 'manager'
    state.userId = getTokenData().userId
    state.userRole = getTokenData().userRole
    state.userName = getTokenData().userName
  },
  [types.REGISTER](state) {
    displayInfo('E-mail, który umożliwi aktywację konta, został wysłany na podany przez Ciebie adres.')
    router.push({
      path: '/login'
    });
  },
  [types.FORGOTPASSWORD](state) {
    displayInfo('E-mail, który umożliwi zmianę hasła, został wysłany na podany przez Ciebie adres.')
    router.push({
      path: '/login'
    });
  },
  [types.LOGOUT](state) {
    state.from = ''
    state.isLoggedIn = false
    state.isInAdminRole = false
    state.userId = ''
    state.userRole = ''
    state.userName = ''
    state.enums = []
    router.push({
      path: '/login'
    });
  },
  [types.ENUMS](state, response) {
    state.enums = response.data
  },
}
